
import { Component, Vue, Emit, Watch } from "vue-property-decorator";
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";
import store from "@/store";
import $ from "jquery";
import magnificPopup from "magnific-popup";
const magnificpopup = magnificPopup;
const Words: Dictionary = {
  error:
    "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
  account: "メールアドレス",
  password: "パスワード",
  login: "登録する",
};

interface ErrorType {
  title: string;
  message?: string;
}

@Component({
  components: {
    LoadingAnimation,
  },
})
export default class ModalMghrwcLogin extends Vue {
  private words = Words;

  private name = "ModalMghrwcLogin";
  private loading: boolean = false;
  private showLoading: boolean = false;
  private loadingTimerId: number | null = null;
  private username = null;
  private password = null;
  private error: ErrorType | null = null;
  private forgetMghrwcPwUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_FORGET_PASSWORD_URL}`;
  private signUpMghrwcUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_CREATE_ACCOUNT_URL}`;

  get isOpen(): boolean {
    return store.getters["modalMghrwc/open"];
  }

  @Watch("isOpen")
  private onModalStateChanged(newState: boolean) {
    if (newState) {
      this.open();
    } else {
      this.close();
    }
  }

  @Watch("loading")
  private onChagedLoading(newState: boolean) {
    if (this.loadingTimerId) {
      clearTimeout(this.loadingTimerId);
      this.loadingTimerId = null;
    }
    if (newState) {
      this.loadingTimerId = window.setTimeout(() => {
        this.showLoading = true;
        this.loadingTimerId = null;
      }, 3000);
    } else {
      this.showLoading = false;
    }
  }

  @Emit()
  private close() {
    // if (this.loading) return;
    $.magnificPopup.close();
    store.commit("modalMghrwc/close");
  }
  @Emit()
  private open() {
    const $modalSearch: any = $("#modal_mghrwc_login");
    if (typeof $modalSearch !== "undefined") {
      $.magnificPopup.open({
        items: {
          src: "#modal_mghrwc_login",
          type: "inline",
        },
        callbacks: {
          close() {
            store.commit("modalMghrwc/close");
          },
        },
      });
    }
  }

  @Emit()
  private async onSubmit() {
    if (this.loading) {
      return false;
    }
    this.error = null;
    if (!this.username || !this.password) {
      this.error = {
        title:
          "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
      };
      return false;
    }

    this.loading = true;
    try {
      await store.dispatch("auth/mghrwcLogin", {
        mail: this.username,
        password: this.password,
      });

      this.close();
      window.location.reload();
    } catch (e: any) {
      console.error("modal", e.status);
      if (e.status === 403 || e.status === 400) {
        this.error = {
          title:
            "MGH Rewards Club会員メールアドレス<br>または会員パスワードに誤りがあります。",
        };
      } else {
        if (e.status === 500 && e.message === "MGHRWC connect Error") {
          this.error = {
            title: "システムエラー（OPTIMA接続エラー）",
            message:
              "予約システムへの接続が失敗しました。<br />お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
          };
        } else {
          this.error = {
            title: "システムエラー",
            message:
              "サーバーからの応答が無いため処理を実行できませんでした。<br>お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
          };
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
